import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="ui--tabs-list"
//
// Coordinates a sidebar tab navigation with panels rendered elsewhere in the DOM.
// Panels are looked up globally by [data-tabs-list-id=<id>] and switched via the
// hidden attribute. The active tab is restyled via Tailwind classes.
export default class extends Controller {
  static targets = ["tab"]
  static values = { id: String, active: String }

  static TAB_CLASSES = {
    active: ["bg-primary-100", "text-primary-700"],
    inactive: ["text-gray-600", "hover:bg-gray-100", "hover:text-gray-700"]
  }

  static BADGE_CLASSES = {
    active: ["bg-white", "text-primary-700"],
    inactive: ["bg-gray-200", "text-gray-900"]
  }

  connect() {
    const initial = this.activeValue || this.tabTargets[0]?.dataset.tabName
    if (initial) this.showTab(initial)
  }

  select(event) {
    const tabName = event.currentTarget.dataset.tabName
    this.showTab(tabName)
  }

  showTab(name) {
    this.activeValue = name

    this.tabTargets.forEach(tab => {
      const isActive = tab.dataset.tabName === name
      this._applyClasses(tab, this.constructor.TAB_CLASSES, isActive)
      tab.setAttribute("aria-selected", isActive)

      const badge = tab.querySelector("[data-tab-badge]")
      if (badge) this._applyClasses(badge, this.constructor.BADGE_CLASSES, isActive)
    })

    this._panels().forEach(panel => {
      const isActive = panel.dataset.tabName === name
      panel.classList.toggle("hidden", !isActive)
    })
  }

  _panels() {
    return document.querySelectorAll(`[data-tabs-list-id="${this.idValue}"]`)
  }

  _applyClasses(element, classes, isActive) {
    classes.active.forEach(c => element.classList.toggle(c, isActive))
    classes.inactive.forEach(c => element.classList.toggle(c, !isActive))
  }
}
